module.exports = __webpack_public_path__ + "img/com4.bffd0c6c.gif";